import classNames from "classnames";
import { BaseTextFieldProps } from "./InputField";
import { useField } from "formik";

interface RadioItem {
    text?: string;
    value: string;
}

interface Props extends BaseTextFieldProps {
    items: RadioItem[];
    className?: string;
    onChangeCallback?: (value?: string) => void;
}

export const RadioGroupField = ({
    items,
    className,
    formControlClassName,
    name,
    onChangeCallback,
    ...props
}: Props) => {
    const [field, meta] = useField(name);
    const withError = meta.touched && meta.error;

    return (
        <div className={classNames("radio-group", className)}>
            {items.map(({ value, text }) => (
                <label key={value} className="radio">
                    <input
                        {...field}
                        onChange={(e) => {
                            field.onChange(e);
                            onChangeCallback?.(e.target.value);
                        }}
                        type="radio"
                        className={classNames(formControlClassName, {
                            "is-invalid": withError,
                        })}
                        checked={field.value === value}
                        value={value}
                    />
                    <span className="radio-icon"></span>
                    <span className="radio-text">{text || value}</span>
                </label>
            ))}
            {withError && <div className="form-error">{meta.error}</div>}
        </div>
    );
};
